export { default } from "./category-showcase";
